// extracted by mini-css-extract-plugin
module.exports = {"root":"Main-root-e06382b37f3dd44e0d8677097a5d38bf"};